import React from 'react';
import { createStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/core';
import { Theme } from '@material-ui/core';
import { Button } from '@material-ui/core';
import Delete from '@material-ui/icons/Delete';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        buttonsContainer: {
            position: 'absolute',
            top: 5,
            right: 5,
        },
        buttonDeleteImage: {
            fill: 'rgb(208, 67, 67)',
            color: 'rgb(208, 67, 67)',
            background: 'white',
            minWidth: 30,
            height: 30,
            margin: 0,
            padding: 0,
            '&:hover': {
                background: 'white',
            },
        },
        imgThumb: {
            width: '100%',
            height: '100%',
            objectFit: 'cover',
        },
        imgContainer: {
            width: '296px',
            height: '296px',
            background: '#5e5e5e',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
        },
    })
);

export const SlidePhoto = (props: {
    filename: string;
    fileURL: string;
    idProperty: string;
    idPhoto: string;
    isUpdating: boolean;
    removeThePhoto: (idProperty: string, idPhoto: string, photoName?: string) => void;
}) => {
    const classes = useStyles();
    const onClickDelete = () => {
        props.removeThePhoto(props.idProperty, props.idPhoto, props.filename);
    };

    return (
        <div className={classes.imgContainer}>
            <img
                className={classes.imgThumb}
                src={props.fileURL}
                alt={props.filename ?? 'Sans photo'}
            />
            {props.isUpdating && (
                <div className={classes.buttonsContainer}>
                    <Button
                        variant="outlined"
                        className={classes.buttonDeleteImage}
                        onClick={onClickDelete}
                    >
                        <Delete />
                    </Button>
                </div>
            )}
        </div>
    );
};
